import React from 'react';
import styled from 'styled-components';
import { Textarea as MatTextArea } from 'react-materialize';

const Content = styled.div`
    display: flex;
    margin: ${props => props.margin ? props.margin : '0 0'};
`;

const TextArea = ({
    id,
    placeholder,
    length, 
    margin,
    name,
    value, 
    onChange
}) => {
    return (
        <Content 
            margin={margin}>
            <MatTextArea 
                id={id} 
                placeholder={placeholder}
                maxLength={length}
                name={name}
                value={value}
                onChange={onChange} />
        </Content>
    );
}

export default TextArea;